(function(root){
  'use strict';
  function reviewLabel(data){
    const count=Number(data.numberOfReviews), average=Number(data.averageRating);
    if(!Number.isInteger(count)||count<0||!Number.isFinite(average)||average<0||average>5)return null;
    return count===0?'Sin reseñas todavía':average.toFixed(1).replace('.',',')+' de 5 · '+count+' '+(count===1?'reseña':'reseñas');
  }
  function syncBadge(badge){
    const label=badge.querySelector('.jdgm-prev-badge__text'), value=reviewLabel(badge.dataset);
    if(label&&value!==null&&label.textContent!==value)label.textContent=value;
  }
  function cleanCopy(text){
    return text.replace(/Miagrosa/g,'Milagrosa').replace(/miagrosa/g,'milagrosa').replace(/Grátis/g,'Gratis')
      .replace(/Click Aquí para ver ofertas/g,'Haz clic para ver las ofertas')
      .replace(/Elije tu Oferta/g,'Elige tu oferta').replace(/Tu Escribe tus datos de envío/g,'Escribe tus datos de envío');
  }
  const ctaValues=new WeakMap();
  function styleCta(button){
    const values={background:'linear-gradient(110deg,#d8b66c,#ecd49b)',color:'#35271c','border-radius':'14px',border:'1px solid #b79450','box-shadow':'0 5px 18px #684c2524','font-family':'inherit'};
    const normalized=ctaValues.get(button)||{};
    Object.keys(values).forEach(key=>{
      const current=button.style.getPropertyValue(key);
      if(current!==(normalized[key]||values[key]))button.style.setProperty(key,values[key],'important');
      normalized[key]=button.style.getPropertyValue(key);
    });
    ctaValues.set(button,normalized);
  }
  const formHeadingValues=new WeakMap();
  function styleFormHeading(element){
    const isHeader=element.classList.contains('_rsi-modal-header-title');
    const isStep=/^\s*[1-4]\s*-/.test(element.textContent);
    // Keep coverage warnings and validation messages in their native alert colors.
    if(!isHeader&&!isStep)return;
    const values={color:'#49372a','font-family':isHeader?'Georgia,serif':'Arial,sans-serif','font-size':isHeader?'24px':'18px','text-align':isHeader?'center':'left'};
    const normalized=formHeadingValues.get(element)||{};
    Object.keys(values).forEach(key=>{if(element.style.getPropertyValue(key)!==(normalized[key]||values[key]))element.style.setProperty(key,values[key],'important');normalized[key]=element.style.getPropertyValue(key);});
    formHeadingValues.set(element,normalized);
  }
  const api={reviewLabel,syncBadge,cleanCopy,styleCta};
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(!root.document)return;
  const main=root.document.querySelector('main[data-template="product.manilla-milagrosa-2185057"]');
  if(!main||root.__pulseraEditorialInitialized)return;
  root.__pulseraEditorialInitialized=true;
  function refresh(){
    root.document.querySelectorAll('#_rsi-cod-form-modal ._rsi-modal-header-title,#_rsi-cod-form-modal ._rsi-custom-text-field').forEach(styleFormHeading);
    main.querySelectorAll('.jdgm-prev-badge').forEach(syncBadge);
    root.document.querySelectorAll('._rsi-buy-now-button').forEach(button=>{
      styleCta(button);
      const walker=root.document.createTreeWalker(button,root.NodeFilter.SHOW_TEXT);
      while(walker.nextNode()){const node=walker.currentNode,next=cleanCopy(node.nodeValue);if(next!==node.nodeValue)node.nodeValue=next;}
    });
    // The current product's form is generated outside MainContent by Releasit.
    root.document.querySelectorAll('._rsi-quantity-offers-title,._rsi-build-block-title,._rsi-build-block-header,._rsi-custom-text-field').forEach(element=>{
      const walker=root.document.createTreeWalker(element,root.NodeFilter.SHOW_TEXT);
      while(walker.nextNode()){const node=walker.currentNode,next=cleanCopy(node.nodeValue);if(next!==node.nodeValue)node.nodeValue=next;}
    });
  }
  let scheduled=false;
  const observer=new root.MutationObserver(()=>{if(scheduled)return;scheduled=true;root.requestAnimationFrame(()=>{scheduled=false;refresh();});});
  observer.observe(root.document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
  refresh();
})(typeof window==='undefined'?{}:window);
